import SuccessMessage from "./success_message";

export default SuccessMessage;
